import { UserTypes } from '../../models';
import request from './axiosClient';

// const URL_LOGIN = '/v2/login';
const URL_LOGIN = '/login';
const URL_LOGOUT = '/logout';
const URL_PERMISSION = '/permissions-by-user';

export function loginAPI(data: UserTypes) {
  return request({
    url: URL_LOGIN,
    method: 'post',
    data: { ...data, role: 11 },
    noNeedToken: true,
  });
}

export function logoutAPI(token: string, params: {}) {
  return request({
    url: URL_LOGOUT,
    method: 'get',
    params,
    token,
  });
}
export function getPermissionAPI(token: string) {
  return request({
    url: URL_PERMISSION,
    method: 'get',
    token,
  });
}
